import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataExportComponent } from "@valg-shared/components/table/data-export/data-export.component";
import { TranslateModule } from "@ngx-translate/core";
import { MatIconModule } from "@angular/material/icon";


@NgModule({
  declarations: [ DataExportComponent ],
  exports: [ DataExportComponent ],
  imports: [
    CommonModule,
    TranslateModule,
    MatIconModule
  ]
})
export class DataExportModule { }
